import { render } from "./EventViewUserFieldsEditor.vue?vue&type=template&id=11a5effc&lang=pug"
import script from "./EventViewUserFieldsEditor.vue?vue&type=script&lang=js"
export * from "./EventViewUserFieldsEditor.vue?vue&type=script&lang=js"

import exportComponent from "/builds/mfar.technology/events/events-platform/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__